module.exports = __webpack_public_path__ + "img/clock.7c43166f.svg";